module.exports = __webpack_public_path__ + "img/hero_stacked.3f30e378.png";